(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .config(commonWebConfig);

    commonWebConfig.$inject = ['$httpProvider'];

    function commonWebConfig($httpProvider) {
        $httpProvider.interceptors.push('sessionInjector');
        $httpProvider.interceptors.push('authInterceptor');
    }
})();